/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Toggle_Markers_Aria_LabelInputs */

const en_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Markers`)
};

const fr_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer les marqueurs`)
};

const de_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markierungen umschalten`)
};

const it_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva marcatori`)
};

const ru_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить маркеры`)
};

const es_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de alternancia`)
};

const zh_cn2_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换标记`)
};

const ja_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーを切り替える`)
};

const hi_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर टॉगल करें`)
};

const pt_pt2_timeline_toggle_markers_aria_label = /** @type {(inputs: Timeline_Toggle_Markers_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de alternância`)
};

/**
* | output |
* | --- |
* | "Toggle Markers" |
*
* @param {Timeline_Toggle_Markers_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_toggle_markers_aria_label = /** @type {((inputs?: Timeline_Toggle_Markers_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Toggle_Markers_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_toggle_markers_aria_label(inputs)
	if (locale === "de") return de_timeline_toggle_markers_aria_label(inputs)
	if (locale === "it") return it_timeline_toggle_markers_aria_label(inputs)
	if (locale === "ru") return ru_timeline_toggle_markers_aria_label(inputs)
	if (locale === "es") return es_timeline_toggle_markers_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_toggle_markers_aria_label(inputs)
	if (locale === "ja") return ja_timeline_toggle_markers_aria_label(inputs)
	if (locale === "hi") return hi_timeline_toggle_markers_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_toggle_markers_aria_label(inputs)
	return en_timeline_toggle_markers_aria_label(inputs)
});